var map = {
	"./Article": 30829,
	"./Article/": 30829,
	"./Article/index": 30829,
	"./Article/index.jsx": 30829,
	"./Article/styles.module.css": 50574,
	"./ContactLayout": 73676,
	"./ContactLayout/": 73676,
	"./ContactLayout/SimpleCheckbox": 10903,
	"./ContactLayout/SimpleCheckbox/": 10903,
	"./ContactLayout/SimpleCheckbox/index": 10903,
	"./ContactLayout/SimpleCheckbox/index.jsx": 10903,
	"./ContactLayout/SimpleCheckbox/styles.module.css": 79498,
	"./ContactLayout/SimpleRadioButton": 59473,
	"./ContactLayout/SimpleRadioButton/": 59473,
	"./ContactLayout/SimpleRadioButton/index": 59473,
	"./ContactLayout/SimpleRadioButton/index.jsx": 59473,
	"./ContactLayout/SimpleRadioButton/styles.module.css": 45046,
	"./ContactLayout/index": 73676,
	"./ContactLayout/index.jsx": 73676,
	"./ContactLayout/styles.module.css": 13025,
	"./FooterLayout": 93444,
	"./FooterLayout/": 93444,
	"./FooterLayout/index": 93444,
	"./FooterLayout/index.jsx": 93444,
	"./FooterLayout/styles.module.css": 42113,
	"./ProductsLayout": 46753,
	"./ProductsLayout/": 46753,
	"./ProductsLayout/index": 46753,
	"./ProductsLayout/index.jsx": 46753,
	"./ProductsLayout/styles.module.css": 90105,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921,
	"./VideoLayout": 22723,
	"./VideoLayout/": 22723,
	"./VideoLayout/index": 22723,
	"./VideoLayout/index.jsx": 22723,
	"./VideoLayout/styles.module.css": 15523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;